// extracted by mini-css-extract-plugin
module.exports = {"GirlWriting":"TextGroupSectionA_GirlWriting__LQwfN","Spacer":"TextGroupSectionA_Spacer__2c-7B","TextContainer":"TextGroupSectionA_TextContainer__2uGmt"};